<template>
  <div v-if="!loading" class="bg-gray-300 flex-1">
    <!--
      Header Section
    -->
    <div class="bg-indigo-500 px-16">
      <!--
        Header Before
      -->
      <slot name="header-before" />

      <!--
        Header Main
      -->
      <div class="max-w-5xl mx-auto py-12">
        <slot name="header" />
      </div>
    </div>

    <div class="-mx-16 bg-indigo-500">
      <svg viewBox="0 0 1366 88" preserveAspectRatio="none">
        <polygon
          class="text-indigo-600 fill-current"
          points="0 80 0 88 1366 88 1366 80 1366 0 0 80"
        />
        <polygon
          class="text-gray-300 fill-current"
          points="0 80 0 88 1366 88 1366 80 1366 32 0 80"
        />
      </svg>
    </div>

    <!--
        Header After
      -->
    <div class="max-w-5xl mx-auto">
      <slot name="header-after" />
    </div>

    <!--
      Main Section
    -->
    <div class="p-16">
      <div class="max-w-5xl mx-auto">
        <Transition name="slide-right" mode="out-in">
          <slot />
        </Transition>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SingleLayout',
  props: {
    loading: Boolean,
  },
};
</script>

<style lang="postcss" scoped>
.separator:before {
  content: ' ';
  border-left: 50% solid transparent;
  border-bottom: 50% solid white;
  @apply absolute bg-white inset-0;
}
</style>
